import { View, ScrollView } from "react-native";
import { ms } from "@/ui/moderateScale";
import { useRouter } from "@/_router";
import React, { useEffect } from "react";
import { useUserSlice } from "@/models/useUserSlice";

export default function WebPage({
  children,
  HeaderComponent,
}: {
  children: React.ReactNode;
  HeaderComponent: React.ReactNode;
}) {
  const router = useRouter();

  useEffect(() => {
    useUserSlice.getState().subscription().onStripeCheckoutSuccess({ router });
  }, []);

  return (
    <View style={{ flex: 1 }}>
      {HeaderComponent}
      <ScrollView style={{ flexGrow: 1 }}>{children}</ScrollView>
    </View>
  );
}

WebPage.HEADER_HEIGHT = ms(56);
WebPage.MAX_WIDTH = 1000;
